// JavaScript source code
import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Header from '../components/header';
import SubFooter from '../components/subfooter';
import Input from '../components/input';
import Button from '../components/button';
import Select from '../components/select';
import config from '../config';
import ImageUpload from '../components/imageUpload';
import ConfirmDialog from '../components/confirmDialog';
import MessageDialog from '../components/messageDialog';
import LoadingOverlay from '../components/loadingOverlay';
import Cookies from 'js-cookie';
import { get, post, getBaseURL,getUser} from '../request';
import dataJoinUs from '../assets/fake-data/data-joinus';
import LoginDialog from '../components/loginDialog';
function JoinUsStep2(props) {
    var user = getUser();
    let activeIndex = 3;
    const theData = dataJoinUs;
    var baseURL = getBaseURL();
    const [businessFileList, setBusinessFileList] = useState([]);
    const [item, setItem] = useState({
        name: '',
        yingyeFile: '',
        kaihuFile: '',
        fazhengFile: '',
        fafanFile: '',
        gongsiFile1: '',
        gongsiFile2: '',
        businessInvoiceInfoList: []
        // 可以根据需要添加更多输入字段  
    });
    const [businessLicense, setBusinessLicense] = useState({});

    const [isValid, setIsValid] = useState({
        name: false,
        yingyeFile: false,
        kaihuFile: false,
        fazhengFile: false,
        fafanFile: false,
        taxpayerCode: false,
        bankName: false,
        bankAccount: false,
        taxpayerPhone: false

    });
    const [isValid2, setIsValid2] = useState({
        licenseName:false,
        licenseNo: false,
        licenseStartDate: false,
        licenseExpireDate: false,
        licRegisProvince: false,
        licRegisCity: false,
        licRegisCounty: false,
        licenseAddress: false,        
        acnt_nm: false,
        artifSex: false,
        acnt_certif_id: false,
        certifiIdAddr: false,
        certifiOffice: false,
        certifiOfficeCity: false,
        certifiOfficeCode: false,
        acntCertifExpireDt: false,
        certifIdStartDate: false
    });
    const [data, setData] = useState(null);
    const [itemInvoice, setInvoiceInputs] = useState({
        taxpayerCode: '',
        bankName: '',
        bankAccount: '',
        taxpayerAddress: '',
        taxpayerPhone: ''
        // 可以根据需要添加更多输入字段  
    });
    const [formIsValid, setFormIsValid] = useState(false);
    const [formIsValid2, setFormIsValid2 ]= useState(false);

    const [isShowConfirmDialog, setConfirmDialog] = useState(false);
    const [currentImage, setCurrentImage] = useState(null);
    const [step, setStep] = useState("1");
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setShowLoading] = useState(false);
    const [cities, setCities] = useState([]);
    const [counties, setCountys] = useState([]);
    const [provinces, setProvinces] = useState([]);
    const [allprovinces, setAllProvinces] = useState([]);
    const [allcities, setAllCities] = useState([]);
    const [allcounties, setAllCountys] = useState([]);
    const licenseTypesOptions = [
        { id: '1', name: '三证合一' },
        { id: 'B', name: '个体户' }
    ];
    const genderOptions = [
        { id: '1', name: '女' },
        { id: '2', name: '男' }
    ];
    const [isShowLogin, setIsShowLogin] = useState(false);
    const finishLogin = () => {
        setIsShowLogin(false);
        //navigate("/JoinUsStep");
        user = getUser();
    }
    useEffect(() => {
        loadData();
    }, []);
    const loadData = () => {
        if (user && user.userType == 1) {
            setShowLoading(true);
            get('delianapi/business/my').then((response) => {
                setShowLoading(false);
                if (response.statusCode !== 200 || response.items.length == 0) {
                    return;
                }
                var data = response.items[0];
                setData(data);
                setItem(data);
                setBusinessFileList(data.businessFileList);
                if (data.businessInvoiceInfoList && data.businessInvoiceInfoList.length > 0) {
                    setInvoiceInputs(data.businessInvoiceInfoList[0]);
                    ["taxpayerCode", "bankName", "bankAccount", "taxpayerPhone"].forEach(function (key) {
                        if (data.businessInvoiceInfoList[0][key]) {
                            setIsValid(oldIsValid => {
                                oldIsValid[key] = true
                                return oldIsValid;
                            });
                        }
                    });
                }
                

                if (data.gongsiFile) {
                    if (data.gongsiFile.length > 0) {
                        setItem(prevFormData => ({
                            ...prevFormData,
                            ["gongsiFile1"]: data.gongsiFile[0]
                        }));
                        if (data.gongsiFile.length > 1) {
                            setItem(prevFormData => ({
                                ...prevFormData, ["gongsiFile2"]: data.gongsiFile[1]
                            }));
                        }
                    }
                }
                ["name","yingyeFile", "kaihuFile", "fazhengFile", "fafanFile", "gongsiFile1", "gongsiFile2"].forEach(function (key) {
                    if (data[key]) {
                        setIsValid(oldIsValid => {
                            oldIsValid[key] = true
                            return oldIsValid;
                        });
                    }
                });                
                validateForm();
                getallprovince();
            });

        }
    };

    // 验证表单  
    const validateForm = () => {
        const timer = setTimeout(() => {
            const isAllFieldsFilled = Object.values(isValid).every(value => value);
            setFormIsValid(isAllFieldsFilled);
            clearTimeout(timer);
        }, 1000);        
    };
    const validateForm2 = () => {
        const timer = setTimeout(() => {
            const isAllFieldsFilled = Object.values(isValid2).every(value => value);
            setFormIsValid2(isAllFieldsFilled);
            clearTimeout(timer);
        }, 1000);
    };
    const handleInputChange = (name, value, name1) => {
        if (name1 == "businessInvoiceInfoList") {
            setInvoiceInputs({ ...itemInvoice, [name]: value });
        }
        else if (name1 == "businessLicense") {
            setBusinessLicense({ ...businessLicense, [name]: value });
        }
        else {
            setItem(prevFormData => ({
                ...prevFormData, [name]: value
            }));
        }
    };
    const submit = () => {
        setSuccessMessage("");
        setErrorMessage("");
        setShowLoading(true);
        if (item.businessInvoiceInfoList.length == 0) {
            item.businessInvoiceInfoList.push(itemInvoice);
        }
        if (item.businessInvoiceInfoList.length > 0) {
            item.businessInvoiceInfoList[0] = {
                ...item.businessInvoiceInfoList[0],
                ...itemInvoice
            };
        }        
        if (item.businessInvoiceInfoList.length > 1 && !item.businessInvoiceInfoList[1].taxpayerCode) {
            item.businessInvoiceInfoList[1].taxpayerCode = item.businessInvoiceInfoList[0].taxpayerCode;
        }
        item.businessLicenseEntity = businessLicense;
        post('delianapi/business/joinnew', item).then((response) => {
            setShowLoading(false);
            if (response.statusCode !== 200 || response.items.length == 0) {
                setErrorMessage(response.message);
                return;
            }
            setSuccessMessage("您的资料已提交，请耐心等待，我们将即时与您联系");
        });
    };
    const recognition = (step) => {
        setSuccessMessage("");
        setErrorMessage("");
        setShowLoading(true);       
        item.businessFileList = businessFileList;
        post('delianapi/business/recognition', item).then((response) => {
            setShowLoading(false);
            if (response.statusCode !== 200 || response.items.length == 0) {
                setErrorMessage(response.message);
                return;
            }
            else {
                var data = response.items[0];
                data.businessLicenseEntity.acntCertifExpireDt = converDate(data.businessLicenseEntity.acntCertifExpireDt );
                data.businessLicenseEntity.certifIdStartDate = converDate(data.businessLicenseEntity.certifIdStartDate);
                data.businessLicenseEntity.artifBirthday = converDate(data.businessLicenseEntity.artifBirthday);
                data.businessLicenseEntity.licenseStartDate = converDate(data.businessLicenseEntity.licenseStartDate);
                data.businessLicenseEntity.licenseExpireDate = converDate(data.businessLicenseEntity.licenseExpireDate);

                var thePros = allprovinces.filter(function (province) {
                    return province.provinceName == data.businessLicenseEntity.licRegisProvince;
                });
                if (thePros.length > 0) {
                    var citys = thePros[0].childList.map(function (city) {
                        return { id: city.cityName, name: city.cityName };
                    })
                    setCities(citys);
                }
                var theCities = allcities.filter(function (city) {
                    return city.cityName == data.businessLicenseEntity.licRegisCity;
                });
                if (theCities.length > 0) {
                    var countys = theCities[0].childList.map(function (county) {
                        return { id: county.countyName, name: county.countyName };
                    })
                    setCountys(countys);
                }
                setItem(data);
                if (data.businessLicenseEntity) {
                    setBusinessLicense(data.businessLicenseEntity);                    
                }
                setStep(step);
                setSuccessMessage("请仔细核对系统自动识别的信息！");

                Object.keys(isValid2).forEach((key) => {
                    if (data.businessLicenseEntity[key]) {
                        setIsValid2(oldIsValid => {
                            oldIsValid[key] = true
                            return oldIsValid;
                        });
                    }
                });
                //["artifSex", "licRegisProvince", "licRegisCity","licRegisCounty"].forEach(function (key) {
                   
                //});
                validateForm2();
            }

        });
    }    
    const navigate = useNavigate();
    const goToStep = (step) => {
        if (step == 0) {
            navigate(config.root + '/JoinUsStep');
        }
        if (step == 1) {
            setStep(1);
        }
        if (step == 2) {
            validateForm();
            if (!formIsValid) {
                setErrorMessage("信息需要填全！");
            }
            else {
                recognition(step);
            }
        }
    };
    const handleValidInput = (name, isNewValid, name1) => {
        if (name1) {
            setIsValid2(isValid2 => {
                isValid2[name] = isNewValid;
                return isValid2;
            });
            validateForm2();
        }
        else {
            setIsValid(isValid => {
                isValid[name] = isNewValid;
                return isValid;
            });
            validateForm();
        }        
    }
    
    const getallprovince = () => {
        get("delianapi/businessLicense/gettreeprovince").then((response) => {
            setAllProvinces(response.items);
            var cities = [];
            var counties = [];
            var provinces = response.items.map(function (pro) {
                cities = cities.concat(pro.childList);
                pro.childList.forEach(function (city) {
                    counties = counties.concat(city.childList);
                })
                return { id: pro.provinceName, name: pro.provinceName};
            });
            setProvinces(provinces);
            setAllCities(cities);
            var cityOptions = cities.map(function (city) {
                return { id: city.cityName, name: city.cityName };
            })
            setCities(cityOptions);
            setAllCountys(counties);
            var countyOptions = counties.map(function (county) {
                return { id: county.countyName, name: county.countyName };
            })
            setCountys(countyOptions);
        });
    };
    const deleteFile = (name, evidenceType, imageSrc) => {
        setCurrentImage({
            evidenceType: evidenceType,
            imageSrc: imageSrc,
            name: name
        });
        setConfirmDialog(true);
    }
   
    const confirmDeleteFinish = (data) => {
        if (data) {            
            setItem(prevFormData => {
                prevFormData[data.name]= '';
                return prevFormData;
            });
            setCurrentImage(null);
            setConfirmDialog(false);
            setIsValid(isValid => {
                isValid[data.name] = false
                return isValid;
            });

            var files = businessFileList.filter(function (fileEntity) {
                return !(fileEntity.evidenceType == data.evidenceType && data.imageSrc == fileEntity.fileAddress);
            });
            setBusinessFileList(files);

            //setItem({ ...item, ['businessFileList']: files });

            validateForm();
        }
    }
    const download2017 = () => {
        var Authorization = localStorage.getItem('Authorization');
        Cookies.set('Authorization', Authorization, { path: '/' });
        window.location.href = baseURL + '/delianapi/business/downloadcontract2017?t=' + (new Date()).getTime();

        //post('delianapi/business/join', item).then((response) => {
        //});
    };

    const handleImageChange = (name, imgUrl, evidenceType) => {
        var fileEntity = {
            evidenceType: evidenceType,
            fileAddress: imgUrl,
            name: name
        };
        setItem(prevFormData => {
            prevFormData[name] = imgUrl;
            return prevFormData;
        });

        setIsValid(isValid => {
            isValid[name] = true
            return isValid;
        });
        var files= businessFileList.filter(function (fileEntity) {
            return fileEntity.evidenceType == evidenceType;
        });
        if (files.length == 0) {
            businessFileList.push(fileEntity);
        }
        else {
            if (evidenceType != 4) {
                businessFileList.map(function (fileEntity) {
                    if (fileEntity.evidenceType == evidenceType) {
                        fileEntity.fileAddress = imgUrl;
                        return fileEntity;
                    }
                });
            }
            else {
                var files = businessFileList.filter(function (fileEntity) {
                    return !(fileEntity.evidenceType == 4 );
                });
                if (item.gongsiFile1) {
                    files.push({
                        evidenceType: 4,
                        fileAddress: item.gongsiFile1,
                        name: "公司图片1"
                    });
                }
                if (item.gongsiFile2) {
                    files.push({
                        evidenceType: 4,
                        fileAddress: item.gongsiFile2,
                        name: "公司图片2"
                    });
                }
            }
        }
        setBusinessFileList(businessFileList);
        //setItem({ ...item, ['businessFileList']: item.businessFileList });
        validateForm();
    }
    const handleSelectChange = (name, newValue) => {        
        setBusinessLicense(prevFormData => ({
            ...prevFormData,
            [name]: newValue
        }));     

        if (name == "licRegisProvince") {
            var thePros = allprovinces.filter(function (province) {
                return province.provinceName == newValue;

            });
            if (thePros.length > 0) {
                //setAllCities(thePros[0].childList);
                var citys = thePros[0].childList.map(function(city){
                    return { id: city.cityName, name: city.cityName };
                })
                setCities(citys);                
                //如果直辖市
                if (citys.length >= 1) {
                    var theCities = allcities.filter(function (city) {
                        return city.cityName == citys[0].id;
                    });
                    if (theCities.length > 0) {
                        setBusinessLicense({ ...businessLicense, ["cityCode"]: theCities[0].cityCode });
                        setBusinessLicense({ ...businessLicense, ["licRegisCity"]: theCities[0].cityName });
                        //setAllCountys(theCities[0].childList);
                        var countys = theCities[0].childList.map(function (county) {
                            return { id: county.countyName, name: county.countyName };
                        })
                        setCountys(countys);
                    }
                }
                else {
                    setCountys([]);
                }
            }
        }
        if (name == "licRegisCity") {
            var theCities = allcities.filter(function (city) {
                return city.cityName == newValue;
            });
            if (theCities.length > 0) {                
                setBusinessLicense({ ...businessLicense, ["cityCode"]: theCities[0].cityCode });
                setBusinessLicense({ ...businessLicense, ["licRegisCity"]: theCities[0].cityName });
                //setAllCountys(theCities[0].childList);
                var countys = theCities[0].childList.map(function (county) {
                    return { value: county.countyName, name: county.countyName };
                })
                setCountys(countys);
            }
        }
        if (name == "licRegisCounty") {
            var theCounties = allcounties.filter(function (county) {
                return county.countyName == newValue;

            });
            if (theCounties.length > 0) {
                setBusinessLicense({ ...businessLicense, ["countiCode"]: theCounties[0].countyCode });
                setBusinessLicense({ ...businessLicense, ["licRegisCounty"]: theCounties[0].countyName });
            }
        }

        if (newValue) {
            setIsValid2(isValid2 => {
                isValid2[name] = true;
                return isValid2;
            });
        }
        else {
            setIsValid2(isValid2 => {
                isValid2[name] = false;
                return isValid2;
            });
        }
        validateForm2();

    };
    const certifiOfficeCityBlur = (event) => {
        var city = event.target.id;
        if (city) {
            get("delianapi/businessLicense/getcodebycityname/" + city).then((response) => {
                if (response.statusCode !== 200 || response.items.length == 0) {
                    return;
                }
                var data = response.items[0];
                if (data.code) {
                    setBusinessLicense({ ...businessLicense, ["certifiOfficeCode"]: data.code });
                }
            });
        }        
    }
    const converDate = (dateTimeString) => {
        if (dateTimeString) {
            const date = new Date(dateTimeString);
            date.setDate(date.getDate() + 1);
            return date.toISOString().split('T')[0];
        }
        return "";
    }
    return (
        <div className={`aboutUs joinUs joinUs2`} >            
            <Header activeIndex={activeIndex} user={user} setIsShowLogin={setIsShowLogin}/>
            <div className="content js_content">
                <div className="pageHead">
                    <div className="pageTitle">{theData.pageTitle}</div>
                    <div className="pageSubTitle">{theData.pageSubTitle}</div>
                    <div className="pageDetail">{theData.pageDetail}</div>
                </div>
                <div className="subcontent">
                    <div className="title">服务商注册</div>
                    <div className="step_content">
                        {step == 1 &&
                            <div className="step_detail step_detail1">
                                <div className="step_subtitle">公司注册信息
                                    <span className="smallRed">请上传清晰、完整的原件照片或彩色扫描件  </span>
                                </div>
                            <ImageUpload imageTitle="请上传营业执照" name="yingyeFile" deleted={deleteFile}
                                evidenceType={1 } imageSrc={item.yingyeFile ||"" } uploaded={handleImageChange}
                                />
                            <ImageUpload imageTitle="上传开户许可证" name="kaihuFile" deleted={deleteFile}
                                evidenceType={6} imageSrc={item.kaihuFile || "" } uploaded={handleImageChange}                            />
                            <Input className="input" placeholder="服务商名称(必填)" value={item.name || "" }
                                name="name" onChange={value => handleInputChange('name', value)}
                                checkUniq={true} entityId={item.id} validType="Business" columnName="Name"
                                    checkRequied={true} onValidInput={handleValidInput} />
                            <Input className="input" placeholder="纳税人识别号(必填)" value={itemInvoice.taxpayerCode || "" }
                                    name="taxpayerCode" onChange={value => handleInputChange('taxpayerCode', value, 'businessInvoiceInfoList')}
                                    checkRequied={true} onValidInput={handleValidInput} />
                            <Input className="input" placeholder="基本开户银行名称(必填)"
                                value={itemInvoice.bankName || "" } checkRequied={true} onValidInput={handleValidInput}
                                    name="bankName" onChange={value => handleInputChange('bankName', value, 'businessInvoiceInfoList')} />
                            <Input className="input" placeholder="基本开户账号(必填)" value={itemInvoice.bankAccount || "" }
                                    name="bankAccount" onChange={value => handleInputChange('bankAccount', value, 'businessInvoiceInfoList')}
                                    checkRequied={true} onValidInput={handleValidInput} />
                            <Input className="input" placeholder="邮政编码" value={item.zipCode || "" }
                                name="zipCode" onChange={value => handleInputChange('zipCode', value)}
                                pattern="/^\d{6}$/" onValidInput={handleValidInput} />

                            <Input className="input" placeholder="注册固定电话(必填)" value={itemInvoice.taxpayerPhone || "" }
                                    name="taxpayerPhone" onChange={value => handleInputChange('taxpayerPhone', value, 'businessInvoiceInfoList')}
                                    checkRequied={true} onValidInput={handleValidInput} />

                            <Input className="input input650" placeholder="客户留言" value={item.remark || "" }
                                    name="remark" onChange={value => handleInputChange('remark', value)} />

                            <div className="step_subtitle">法人身份信息
                                <span className="smallRed">请上传清晰、完整的原件照片或彩色扫描件  </span>
                            </div>
                            <ImageUpload className="renxiang" imageTitle="请上传法人身份证人像面" name="fazhengFile"
                                deleted={deleteFile} imageSrc={item.fazhengFile || "" } evidenceType={2}   uploaded={handleImageChange}/>
                            <ImageUpload className="guohui" imageTitle="请上传法人身份证国徽面" name="fafanFile"
                                deleted={deleteFile} imageSrc={item.fafanFile || "" } evidenceType={3}   uploaded={handleImageChange}/>

                            <div className="step_subtitle">上传区域服务商办公地场景
                                <span className="smallRed">请上传清晰的办公场地室内、外照片  </span>
                            </div>
                            <ImageUpload imageTitle="上传室内照" name="gongsiFile1"
                                evidenceType={4} deleted={deleteFile} imageSrc={item.gongsiFile1 || "" }
                                uploaded={handleImageChange} />
                            <ImageUpload imageTitle="上传室外照" name="gongsiFile2"
                                evidenceType={4} deleted={deleteFile} imageSrc={item.gongsiFile2 || "" }
                                uploaded={handleImageChange} />                            

                            <div className="buttonDiv">
                                <Button btnclass="join_btn " onClick={() => goToStep(0)} title="上一步" />
                                <Button btnclass="join_btn " onClick={() => goToStep(2)} title="下一步" disabled={!formIsValid}/>
                                </div>
                            </div>
                        }
                        {
                            step == 2 &&
                            <div className="step_detail step_detail1">
                                <div className="step_subtitle">公司营业执照信息
                                    <span className="smallRed">请仔细核对信息是否正确  </span>
                                </div>
                                <Input className="input " placeholder="证件号码" value={businessLicense.licenseName || ""}
                                    name="licenseName" onChange={value => handleInputChange('licenseName', value, "businessLicense")}
                                    checkRequied={true} onValidInput={handleValidInput} name1="businessLicense" />
                                <Input className="input " placeholder="证件号码" value={businessLicense.licenseNo || ""}
                                    name="licenseNo" onChange={value => handleInputChange('licenseNo', value, "businessLicense")}
                                    checkRequied={true} onValidInput={handleValidInput} name1="businessLicense" />
                                <Select className="width200" placeholder="证照类型" name="license_type" options={licenseTypesOptions} initialValue={businessLicense.license_type || ""}
                                    onChange={handleSelectChange } />                               
                                <Input inputType="date" className="input input200" placeholder="营业期限开始" value={businessLicense.licenseStartDate || ""}
                                    name="licenseStartDate" onChange={value => handleInputChange('licenseStartDate', value, "businessLicense")}
                                    checkRequied={true} onValidInput={handleValidInput} name1="businessLicense" />
                                <Input inputType="date" className="input input200" placeholder="营业期限结束" value={businessLicense.licenseExpireDate || ""}
                                    name="licenseExpireDate" onChange={value => handleInputChange('licenseExpireDate', value, "businessLicense")}
                                    checkRequied={true} onValidInput={handleValidInput} name1="businessLicense" />
                                <Select className="width200" placeholder="省" name="licRegisProvince" options={provinces} initialValue={businessLicense.licRegisProvince || ""}
                                    onChange={handleSelectChange} />
                                <Select className="width200" placeholder="市" name="licRegisCity" options={cities}   initialValue={businessLicense.licRegisCity || ""}
                                    onChange={handleSelectChange} />
                                <Select className="width200" placeholder="区" name="licRegisCounty" options={counties} initialValue={businessLicense.licRegisCounty || ""}
                                    onChange={handleSelectChange} />
                                <Input className="input input650" placeholder="证照地址" value={businessLicense.licenseAddress || ""}
                                    name="licenseAddress" onChange={value => handleInputChange('licenseAddress', value, "businessLicense")}
                                    checkRequied={true} onValidInput={handleValidInput} name1="businessLicense" />
                                <div className="step_subtitle">法人身份证信息
                                    <span className="smallRed">请仔细核对信息是否正确  </span>
                                </div>
                                <Input className="input input200" placeholder="法人姓名" value={businessLicense.acnt_nm || ""}
                                    name="acnt_nm" onChange={value => handleInputChange('acnt_nm', value, "businessLicense")}
                                    checkRequied={true} onValidInput={handleValidInput} name1="businessLicense" />
                                <Input inputType="date" className="input input200" placeholder="出生日期" value={businessLicense.artifBirthday || ""}
                                    name="artifBirthday" onChange={value => handleInputChange('artifBirthday', value, "businessLicense")}
                                    checkRequied={true} onValidInput={handleValidInput} name1="businessLicense" />

                                <Select className="width200" placeholder="性别" name="artifSex" options={genderOptions} initialValue={businessLicense.artifSex || ""}
                                    onChange={handleSelectChange} />

                                <Input className="input input200" placeholder="身份证号码" value={businessLicense.acnt_certif_id || ""}
                                    name="acnt_certif_id" onChange={value => handleInputChange('acnt_certif_id', value, "businessLicense")}
                                    checkRequied={true} onValidInput={handleValidInput} name1="businessLicense" />
                                <Input inputType="date" className="input input200" placeholder="有效期开始" value={businessLicense.certifIdStartDate || ""}
                                    name="certifIdStartDate" onChange={value => handleInputChange('certifIdStartDate', value, "businessLicense")}
                                    checkRequied={true} onValidInput={handleValidInput} name1="businessLicense" />
                                <Input inputType="date" className="input input200" placeholder="有效期结束" value={businessLicense.acntCertifExpireDt || ""}
                                    name="acntCertifExpireDt" onChange={value => handleInputChange('acntCertifExpireDt', value, "businessLicense")}
                                    checkRequied={true} onValidInput={handleValidInput} name1="businessLicense" />

                                <Input className="input input650" placeholder="登记地址" value={businessLicense.certifiIdAddr || ""}
                                    name="certifiIdAddr" onChange={value => handleInputChange('certifiIdAddr', value, "businessLicense")}
                                    checkRequied={true} onValidInput={handleValidInput} name1="businessLicense" />
                                <Input className="input input200" placeholder="发证机关" value={businessLicense.certifiOffice || ""}
                                    name="certifiOffice" onChange={value => handleInputChange('certifiOffice', value, "businessLicense")}
                                    checkRequied={true} onValidInput={handleValidInput} name1="businessLicense" />

                                <Input className="input input200" placeholder="发证城市" value={businessLicense.certifiOfficeCity || ""}
                                    name="certifiOfficeCity" onChange={value => handleInputChange('certifiOfficeCity', value, "businessLicense")}
                                    checkRequied={true} onValidInput={handleValidInput} name1="businessLicense" onBlur={certifiOfficeCityBlur }/>

                                <Input className="input input200" placeholder="发证机关代码" value={businessLicense.certifiOfficeCode || ""}
                                    name="certifiOfficeCode" onChange={value => handleInputChange('certifiOfficeCode', value, "businessLicense")}
                                    checkRequied={true} onValidInput={handleValidInput} name1="businessLicense" />

                                <div className="step_download" onClick={() => download2017()}>点击下载《服务商入驻合同》</div>
                                <div className="buttonDiv">
                                    <Button btnclass="join_btn " onClick={() => goToStep(1)} title="上一步" />
                                    <Button btnclass="join_btn " onClick={() => submit()} title="确认提交" disabled={!formIsValid2}/>
                                </div>
                            </div>
                        }
                    </div>

                </div>
            </div>
            <SubFooter />
            <LoginDialog isShowLogin={isShowLogin} onCancel={finishLogin} />
            <ConfirmDialog isShowConfirmDialog={isShowConfirmDialog}
                message="确定要删除吗？"
                data={currentImage}
                onConfirm={confirmDeleteFinish}
                onCancel={() => { setConfirmDialog(false) }}
            />
            <MessageDialog message={successMessage || errorMessage} onCancel={() => {
                setSuccessMessage("");
                setErrorMessage("");
            }} />
            <LoadingOverlay isLoading={isLoading}>
            </LoadingOverlay>
        </div>

    );
}

export default JoinUsStep2;